import { render, staticRenderFns } from "./beforeBirthday.vue?vue&type=template&id=72f65c22&scoped=true&"
import script from "./beforeBirthday.vue?vue&type=script&lang=js&"
export * from "./beforeBirthday.vue?vue&type=script&lang=js&"
import style0 from "./beforeBirthday.vue?vue&type=style&index=0&id=72f65c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f65c22",
  null
  
)

export default component.exports